import {httpGet, httpPut, httpDelete, httpPost, httpDownload} from '../../../util/request.js';
import appConfig from '../../../config';

export default class CsApi {
    static baseUrl = appConfig.gatewayUrl+appConfig.appointmentServicePath;
    // static baseUrl = "http://localhost:20065/appointment-service";

    static hasRefund(){
        return httpGet(this.baseUrl + "/cs/hasRefund", {})
    }

    static listOrd(param){
        return httpGet(this.baseUrl + "/cs/ord", param);
    }

    static computerNum(param){
        return httpPost(this.baseUrl + "/cs/num/computer", param);
    }

    static listGoods(param){
        return httpGet(this.baseUrl + "/cs/goods", param);
    }

    static goodsTemplate(params){
        return httpDownload(this.baseUrl + "/cs/goods/template",params);
    }

    static importGoods(file, venderId){
        let formData = new FormData()
        formData.append('file', file);
        formData.append('venderId', venderId);
        return httpPost(this.baseUrl + "/cs/goods/import", formData);
    }

    static listCategory(){
        return httpGet(this.baseUrl + "/cs/category",{});
    }
}